import { render, staticRenderFns } from "./research-1001-data-scientists-2018-2020.vue?vue&type=template&id=fb88a970&"
import script from "./research-1001-data-scientists-2018-2020.vue?vue&type=script&lang=js&"
export * from "./research-1001-data-scientists-2018-2020.vue?vue&type=script&lang=js&"
import style0 from "./research-1001-data-scientists-2018-2020.vue?vue&type=style&index=0&id=fb88a970&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports